import { render, staticRenderFns } from "./data62.vue?vue&type=template&id=f9ec63d2&scoped=true&"
import script from "./data62.vue?vue&type=script&lang=js&"
export * from "./data62.vue?vue&type=script&lang=js&"
import style1 from "./data62.vue?vue&type=style&index=1&id=f9ec63d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9ec63d2",
  null
  
)

export default component.exports